import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type CancelButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const CancelButton = ({
    label = "Cancel",
    loadingText = "Cancelling...",
    variant = "outline",
    ...props
}: CancelButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="cancel"
            testId="cancel-button"
            buttonType="button"
            variant={variant}
            {...props}
        />
    );
};

export default CancelButton;
